import { render, staticRenderFns } from "./JurisdictionWideAssumptions.vue?vue&type=template&id=89542e4c&"
import script from "./JurisdictionWideAssumptions.vue?vue&type=script&lang=js&"
export * from "./JurisdictionWideAssumptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports